module.exports = __webpack_public_path__ + "img/main_background.45bdb8b2.svg";